import React from 'react'
import SwitchAccount from '../../../Components/Organisms/SwitchAccount/SwitchAccount'

const SwitchAccountTemplate = ({Logout, setIsAuth, BulkLogout}) => {
  return (
    <SwitchAccount Logout={Logout} setIsAuth={setIsAuth} BulkLogout={BulkLogout} />
  )
}

export default SwitchAccountTemplate